// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
    margin-top: 30px;
}

.carousel-item {
    border: 2px solid black;
    height: 420px;
    width: 150px;
    background-position-y: center; 
    background-size: 100%;
    background-color: rgb(255 255 255 / 50%);
    background-blend-mode: screen;
}

.carousel-item-2by3 {
    border: 2px solid black;
    height: 450px;
    width: 205px;
    background-position-y: center; 
    background-size: 100%;
    background-color: rgb(255 255 255 / 50%);
    background-blend-mode: screen;
}

.scanning {
    border: 2px solid rgb(104, 87, 87);
    height: 480px;
    width: 160px;
}

@keyframes shadow-pulse4 {
    0% {
        box-shadow: 0 0 0 0 rgba(168, 174, 176, 0.4);
    }
    70% {
        box-shadow: 0 0 4px 10px rgba(142, 150, 157, 0.8);
    }
    100% {
        box-shadow: 0 0 0 0 rgb(44, 204, 191, 0.2);
    }

}


@keyframes shadow-pulse5 {
    0% {
        box-shadow: 0 0 0 0 rgb(44, 159, 204, 0.4);
    }
    70% {
        box-shadow: 0 0 8px 4px rgb(44, 119, 204, 0.8);
    }
    100% {
        box-shadow: 0 0 0 0 rgb(44, 204, 191, 0.2);
    }
}


@keyframes shadow-pulse-warn {
    0% {
        box-shadow: 0 0 0 0 rgba(204, 161, 44, 0.4);
    }
    70% {
        box-shadow: 0 0 8px 0 rgba(204, 153, 44, 0.8);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(180, 204, 44, 0.2);
    }
}


@keyframes shadow-pulse-error {
    0% {
        box-shadow: 0 0 0 0 #ff4d4f;
    }
    70% {
        box-shadow: 0 0 8px 0 #ff4d4f;
    }
    100% {
        box-shadow: 0 0 0 0 #ff4d4f;
    }
}

@keyframes shadow-pulse-focus {
    0% {
        box-shadow: 0 0 0 0 #ffffff;
    }
    70% {
        box-shadow: 0 0 8px 0 #7200ff;
    }
    100% {
        box-shadow: 0 0 0 0 #5000b7;
    }
}

@keyframes slot-pulse-focus {
    0% {
        box-shadow: 0 0 0 0 #ffffff;
    }
    70% {
        box-shadow: 0 0 8px 4px #7200ff;
    }
    100% {
        box-shadow: 0 0 0 0 #5000b7;
    }
}`, "",{"version":3,"sources":["webpack://./src/asset/style/workflow/scan-progress.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,qBAAqB;IACrB,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,qBAAqB;IACrB,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,4CAA4C;IAChD;IACA;QACI,iDAAiD;IACrD;IACA;QACI,0CAA0C;IAC9C;;AAEJ;;;AAGA;IACI;QACI,0CAA0C;IAC9C;IACA;QACI,8CAA8C;IAClD;IACA;QACI,0CAA0C;IAC9C;AACJ;;;AAGA;IACI;QACI,2CAA2C;IAC/C;IACA;QACI,6CAA6C;IACjD;IACA;QACI,2CAA2C;IAC/C;AACJ;;;AAGA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,+BAA+B;IACnC;IACA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".carousel {\n    margin-top: 30px;\n}\n\n.carousel-item {\n    border: 2px solid black;\n    height: 420px;\n    width: 150px;\n    background-position-y: center; \n    background-size: 100%;\n    background-color: rgb(255 255 255 / 50%);\n    background-blend-mode: screen;\n}\n\n.carousel-item-2by3 {\n    border: 2px solid black;\n    height: 450px;\n    width: 205px;\n    background-position-y: center; \n    background-size: 100%;\n    background-color: rgb(255 255 255 / 50%);\n    background-blend-mode: screen;\n}\n\n.scanning {\n    border: 2px solid rgb(104, 87, 87);\n    height: 480px;\n    width: 160px;\n}\n\n@keyframes shadow-pulse4 {\n    0% {\n        box-shadow: 0 0 0 0 rgba(168, 174, 176, 0.4);\n    }\n    70% {\n        box-shadow: 0 0 4px 10px rgba(142, 150, 157, 0.8);\n    }\n    100% {\n        box-shadow: 0 0 0 0 rgb(44, 204, 191, 0.2);\n    }\n\n}\n\n\n@keyframes shadow-pulse5 {\n    0% {\n        box-shadow: 0 0 0 0 rgb(44, 159, 204, 0.4);\n    }\n    70% {\n        box-shadow: 0 0 8px 4px rgb(44, 119, 204, 0.8);\n    }\n    100% {\n        box-shadow: 0 0 0 0 rgb(44, 204, 191, 0.2);\n    }\n}\n\n\n@keyframes shadow-pulse-warn {\n    0% {\n        box-shadow: 0 0 0 0 rgba(204, 161, 44, 0.4);\n    }\n    70% {\n        box-shadow: 0 0 8px 0 rgba(204, 153, 44, 0.8);\n    }\n    100% {\n        box-shadow: 0 0 0 0 rgba(180, 204, 44, 0.2);\n    }\n}\n\n\n@keyframes shadow-pulse-error {\n    0% {\n        box-shadow: 0 0 0 0 #ff4d4f;\n    }\n    70% {\n        box-shadow: 0 0 8px 0 #ff4d4f;\n    }\n    100% {\n        box-shadow: 0 0 0 0 #ff4d4f;\n    }\n}\n\n@keyframes shadow-pulse-focus {\n    0% {\n        box-shadow: 0 0 0 0 #ffffff;\n    }\n    70% {\n        box-shadow: 0 0 8px 0 #7200ff;\n    }\n    100% {\n        box-shadow: 0 0 0 0 #5000b7;\n    }\n}\n\n@keyframes slot-pulse-focus {\n    0% {\n        box-shadow: 0 0 0 0 #ffffff;\n    }\n    70% {\n        box-shadow: 0 0 8px 4px #7200ff;\n    }\n    100% {\n        box-shadow: 0 0 0 0 #5000b7;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
